import React from "react"
import { graphql } from "gatsby"
import {
  SEO,
  BaseLayout,
  Breadcrumb,
  ImagePageTitle,
  MdxProviderWithConfig,
} from "../components"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { langId } from "../languages"
import { useFeatureStory } from "../hooks"
import Img from "gatsby-image"

const StoryImageGalleryTemplate = props => {
  // console.log("StoryTemplate", props)
  const featureStory = useFeatureStory()
  const post = props.data.mdx
  const {
    imagePageTitleConfig,
    title,
    seoStaticImg,
    description,
    keywords,
    ogImage,
  } = props.data.mdx.frontmatter
  const { baseSlug, langKey } = props.data.mdx.fields
  const {
    domainUrl,
    publishDate,
    modifiedDate,
    author,
  } = props.data.site.siteMetadata
  const seoImages = seoStaticImg.map(staticImg => `${domainUrl}${staticImg}`)
  return (
    <BaseLayout
      lang={props.pageContext.langKey}
      baseSlug={props.pageContext.baseSlug}
      hasFeatureStory
      defaultSubMenuVisible={true}
    >
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        uriPath={props.uri}
        lang={props.pageContext.langKey}
        baseSlug={baseSlug}
        ogImage={ogImage}
        script={[
          {
            type: "application/ld+json",
            innerHTML: `
            {
              "@context": "https://schema.org",
              "@type": "NewsArticle",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "${domainUrl}/${langKey}/${featureStory.baseSlug}"
              },
              "headline": "${title}",
              "image": ${JSON.stringify(seoImages)},
              "datePublished": "${publishDate}",
              "dateModified": "${modifiedDate}",
              "author": {
                "@type": "Organization",
                "name": "${author}"
              },
               "publisher": {
                "@type": "Organization",
                "name": "${author}",
                "logo": {
                  "@type": "ImageObject",
                  "url": "${domainUrl}/favicon.ico"
                }
              }
            }
            `,
          },
        ]}
      ></SEO>
      <Breadcrumb
        className="story-image-gallery-template__breadcrumb"
        pathArr={[
          { langKey: langId.HOME, baseSlug: "" },
          { langKey: langId.FEATURE_STORIES, baseSlug: "link-feature-stories" },
          {
            langKey: imagePageTitleConfig[0].title,
            baseSlug: post.fields.baseSlug,
          },
        ]}
      ></Breadcrumb>
      <div className="story-image-gallery-template">
        <div className="story-image-gallery-template__banner">
          <Img
            fluid={imagePageTitleConfig[0].img.childImageSharp.fluid}
            alt={imagePageTitleConfig[0].imgAlt}
            title={imagePageTitleConfig[0].imgTitle}
          ></Img>
        </div>
        <div className="story-image-gallery-template__content">
          <MdxProviderWithConfig>
            <MDXRenderer>{post.body}</MDXRenderer>
          </MdxProviderWithConfig>
        </div>
      </div>
    </BaseLayout>
  )
}

export default StoryImageGalleryTemplate

export const pageQuery = graphql`
  query StoryImageGalleryTemplateQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        ...MdxFrontmatterFragment
        seoStaticImg
        imagePageTitleConfig {
          ...MdxFrontmatterImagePageTitleConfigFragment
        }
      }
      fields {
        baseSlug
        langKey
        slug
        urlSlug
      }
    }
    site {
      siteMetadata {
        domainUrl
        publishDate
        modifiedDate
        author
      }
    }
  }
`
